import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classnames from 'classnames';

export function TopRatedCarousel({ children, className = null }) {
  const sliderContainerRef = useRef();

  function slideChange() {
    sliderContainerRef?.current?.querySelectorAll('.slick-slide[aria-hidden="true"] a').forEach(element => {
      element.setAttribute('tabindex', -1);
    });
  }

  function appendDots(dots) {
    return (
      <div>
        <ul className="slick-dots">{dots}</ul>
      </div>
    );
  }

  const sliderOptions = {
    dots: true,
    dotsClass: classnames('mt-0_5 meatballs'),
    appendDots,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.05,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    beforeChange: slideChange,
  };

  useEffect(() => {
    slideChange();
  }, []);

  return (
    <div ref={sliderContainerRef}>
      <Slider className={classnames('trm-slider', className)} {...sliderOptions}>
        {children}
      </Slider>
    </div>
  );
}

TopRatedCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
